module.exports = __webpack_public_path__ + "img/supervision_3000.872ffaa3.png";